import {
	Button,
	Colour,
	DropdownMenu,
	DropdownMenuEntry,
	FlexAlign,
	FlexGap,
	ItemRow,
	ItemRowCell,
	Pill,
	PillSize,
	StackHorizontal,
	ToggleSwitch,
	ToggleType,
	Tooltip,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/pro-solid-svg-icons/faCrown';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faWavePulse } from '@fortawesome/pro-solid-svg-icons/faWavePulse';
import { faCogs } from '@fortawesome/pro-light-svg-icons/faCogs';
import { useAccountUser, UserDataType } from '@ukpostbox/client-data';

interface UserEntryType extends UserDataType {
	passwordResetCallback: any;
	deleteCallback: any;
	disableCallback: any;
}

function SendsUserItem(props: UserEntryType) {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium, isLarge } = useLayout();
	const { data } = useAccountUser();

	const userRole = props?.roles.includes('SENDS_PAGE_ADMIN')
		? 'Admin'
		: props?.roles.includes('MANAGER')
			? 'Manager'
			: 'User';

	return (
		<ItemRow title={`Sends User Entry ${props.userId}`} static sidePadding extraClass='sends-users-row'>
			{!isTiny && !isSmall ? (
				<>
					<ItemRowCell>
						<StackHorizontal gap={FlexGap.ExtraSmall} align={FlexAlign.Center}>
							<Tooltip content={userRole}>
								{userRole === 'User' ? (
									<Pill size={PillSize.Large} content={<FontAwesomeIcon icon={faUser} />} overflow />
								) : (
									<Pill
										size={PillSize.Large}
										colour={userRole === 'Admin' ? Colour.Success : Colour.Secondary}
										content={<FontAwesomeIcon icon={faCrown} />}
										overflow
									/>
								)}
							</Tooltip>
							{props.name}
						</StackHorizontal>
					</ItemRowCell>
					<ItemRowCell>{props.userName}</ItemRowCell>
					{data?.emailAddress !== props.userName && (
						<>
							<ItemRowCell>
								<StackHorizontal gap={FlexGap.ExtraSmall}>
									<Button
										onClick={() => props.passwordResetCallback()}
										title={t('sends.users.actions.passwordReset')}
										squared
										iconOnly={isTiny || isSmall || isMedium || isLarge}
										icon={faEnvelope}
									/>
									<Button
										onClick={() => props.deleteCallback()}
										title={t('sends.users.actions.delete')}
										squared
										iconOnly={isTiny || isSmall || isMedium || isLarge}
										icon={faTrash}
									/>
								</StackHorizontal>
							</ItemRowCell>
							<ItemRowCell>
								<ToggleSwitch
									type={ToggleType.Switch}
									hideLabel
									name={`user${props.userId}`}
									label={t('status.active')}
									defaultChecked={!props.isDisabled}
									onChange={(e: any) => props.disableCallback(!e.currentTarget.checked)}
								/>
							</ItemRowCell>
						</>
					)}
				</>
			) : (
				<>
					<div>
						<h5 className='m-0'>{props.name}</h5>
						{props.userName}
					</div>
					{data?.emailAddress !== props.userName && (
						<div>
							<DropdownMenu
								title='Sends User'
								trigger={
									<Button
										title={t('actions.title')}
										squared
										icon={faCogs}
										iconOnly
										onClick={() => null}
									/>
								}
							>
								<DropdownMenuEntry
									title={t('sends.users.actions.passwordReset')}
									onClick={() => props.passwordResetCallback()}
									icon={faKey}
								/>

								<DropdownMenuEntry
									title={t('isActive')}
									icon={faWavePulse}
									onClick={(e: any) => props.disableCallback(!e.currentTarget.checked)}
									addonContentEnd={
										<ToggleSwitch
											type={ToggleType.Switch}
											hideLabel
											label={t('status.active')}
											name={`user${props.userId}`}
											defaultChecked={props.isDisabled}
										/>
									}
								/>

								<DropdownMenuEntry title={t('divider')} sectionDivider />

								<DropdownMenuEntry
									title={t('sends.users.actions.delete')}
									onClick={() => props.deleteCallback()}
									icon={faTrash}
								/>
							</DropdownMenu>
						</div>
					)}
				</>
			)}
		</ItemRow>
	);
}

export default SendsUserItem;
